export default "__VITE_ASSET__D0o4aT$z__"